import React from 'react';
import { LoadingIndicator } from 'components/LoadingIndicator';


const Loadable = (Component) => (props) => (
  <Component {...props} fallback={<LoadingIndicator show={true} />} />
);


export { Loadable };
